module.exports = __webpack_public_path__ + "static/media/bariatric-image3.a10eb367.png";